"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { ArrowRight, LockKeyhole, Sparkles, UserRound } from "lucide-react";

export default function LoginPage() {
  const router = useRouter();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setLoading(true);
    setError("");
    const response = await fetch("/api/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
    });
    const data = await response.json();
    setLoading(false);
    if (!response.ok) return setError(data.error || "登录失败");
    router.replace("/");
    router.refresh();
  }

  return (
    <main className="login-page">
      <div className="login-glow" />
      <section className="login-brand">
        <div className="brand-mark brand-mark-large"><Sparkles size={25} /></div>
        <p className="eyebrow">PRIVATE DEAL INTELLIGENCE</p>
        <h1>每一个项目，<br />都在同一个工作台。</h1>
        <p className="login-copy">整合交易流程、核心文件、会议记录与项目级 AI 分析，为个人 FA 与投资人打造。</p>
      </section>
      <section className="login-card">
        <div className="login-card-icon"><LockKeyhole size={22} /></div>
        <h2>欢迎回到 Astra</h2>
        <p>使用你的 Astra 账户继续</p>
        <form onSubmit={submit}>
          <label htmlFor="username">用户名</label>
          <div className="login-input"><UserRound size={16} /><input id="username" autoComplete="username" autoFocus value={username} onChange={(event) => setUsername(event.target.value)} /></div>
          <label htmlFor="password">访问密码</label>
          <input id="password" type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} />
          {error && <div className="form-error">{error}</div>}
          <button className="button button-primary button-full" disabled={loading || !username || !password}>
            {loading ? "正在验证…" : "进入工作台"}<ArrowRight size={17} />
          </button>
        </form>
        <small>账户会话仅保存在此浏览器，外部服务密钥始终留在服务器端。</small>
      </section>
    </main>
  );
}
